module.exports = __webpack_public_path__ + "media/images/logo-fa6b65c4413d4c1b1f7557a4a9fd5803.png";